const defaultState = {
  windowLevelData: {
    1: { description: 'Preset #1', window: '500', level: '50' },
    2: { description: 'CT Lung', window: '1600', level: '-400' },
    3: { description: 'CT Abdomen', window: '400', level: '60' },
    4: { description: 'CT Bone', window: '1500', level: '300' },
    5: { description: 'CT Brain', window: '80', level: '40' },
    6: { description: 'CT Chest', window: '400', level: '40' },
    7: { description: 'CT Angio', window: '600', level: '300' },
    8: { description: '', window: '', level: '' },
    9: { description: '', window: '', level: '' },
    10: { description: '', window: '', level: '' },
  },
  generalPreferences: {
    // language: 'en-US'
  },
};

const preferences = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_USER_PREFERENCES': {
      return Object.assign({}, state, action.state);
    }
    default:
      return state;
  }
};

export { defaultState };
export default preferences;
